import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { nonNegativeNumberValidation } from 'validators';
import { InfoIcon, TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import pluralize from '~/utils/pluralize';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function PreapprovedTextField(param) {
    let { suffix } = param;
    const { control, watch } = useFormContext();
    const [isFocused, setIsFocused] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const unitCap = watch('unitCap');
    const unitName = watch('unitName');
    const pricing = watch('pricing');
    const { PREAPPROVED_AMOUNT_IMPROVMENTS = false } = useFeatureFlags();
    useEffect(()=>{
        setIsInfoOpen(isFocused && !!unitCap && +unitCap === 0);
    }, [
        isFocused,
        unitCap
    ]);
    const validate = (value)=>{
        if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
            if (!value || +value <= 0) return 'Set cap (greater than 0)';
            return nonNegativeNumberValidation('Set cap (greater than 0)')(value);
        }
        return nonNegativeNumberValidation('Set cap (0 or higher)')(value);
    };
    const getLabel = ()=>{
        if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
            return "Preapproved amount";
        }
        return "Preapproved ".concat(pricing === 'unit' ? pluralize(unitName) || 'units' : pricing === 'hour' ? 'hours' : '');
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "unitCap",
        rules: {
            validate
        },
        render: (renderProps)=>{
            const _connectControllerToTextField = connectControllerToTextField(renderProps), { onBlur, onChange } = _connectControllerToTextField, rest = _object_without_properties(_connectControllerToTextField, [
                "onBlur",
                "onChange"
            ]);
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                collapseHelperText: false,
                style: {
                    width: '50%'
                },
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                testId: "sb-cap",
                label: getLabel(),
                onFocus: ()=>setIsFocused(true),
                onChange: (e)=>{
                    const trimmedValue = e.target.value.slice(0, 7);
                    onChange({
                        target: {
                            value: trimmedValue
                        }
                    });
                },
                onBlur: ()=>{
                    setIsFocused(false);
                    onBlur();
                }
            }, rest), {
                suffix: PREAPPROVED_AMOUNT_IMPROVMENTS ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: suffix && /*#__PURE__*/ _jsx("span", {
                        "data-testid": "sb-cap-suffix",
                        children: suffix
                    })
                }) : /*#__PURE__*/ _jsx(InfoIcon, {
                    forceOpen: isInfoOpen,
                    testId: "sb-cap-info",
                    info: /*#__PURE__*/ _jsx("div", {
                        "data-testid": "sb-cap-tooltip",
                        children: "Payments up to the set amount don't require client approval. If you input 0, or a payment exceeds the set limit, client approval will be required for the payment."
                    })
                })
            }));
        }
    });
}
